import style from './NoteRecording.module.scss';
import Recording from '../Recording';
import { NOTE_STATUS } from '@ax/constants';
import { selectProviderUserSettings, useAppSelector } from '@ax/redux-store';

interface NoteRecordingProps {
  readonly?: boolean;
}

const NoteRecording = ({ readonly }: NoteRecordingProps) => {
  const providerUserSettings = useAppSelector(selectProviderUserSettings);
  const visitStatus = useAppSelector((state) => state.selectedVisit?.noteStatus);
  const recordButtonEnabled =
    visitStatus !== NOTE_STATUS.NOTE_UPLOADED_TO_EHR &&
    visitStatus !== NOTE_STATUS.NOTE_UPLOADED_TO_MDS;

  return (
    <>
      {providerUserSettings?.recordingFeatureEnabled && recordButtonEnabled && (
        <div className={style.container}>
          <Recording readonly={readonly} />
        </div>
      )}
    </>
  );
};

export default NoteRecording;
